import FilterForm from '../../../components/forms/FilterForm';
import { CrudFilters, HttpError, useCan } from '@refinedev/core';
import {
  EditButton,
  ShowButton,
  TextField,
  useSelect,
  useTable
} from '@refinedev/antd';
import { Form, Input, Select, Space, Table } from 'antd';
import { ICourse } from 'interfaces/courses';
import { IProfessor } from 'interfaces/professor';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { SearchOutlined } from '@ant-design/icons';
import { TitleMap } from 'services/professors';

interface IFilter {
  name: string;
  courseId: string;
  title: string;
  email: string;
}

export const ProfessorsList = () => {
  const canListGraduateCourses = useCan({
    resource: 'graduate_courses',
    action: 'list'
  });

  const { tableProps, searchFormProps } = useTable<
    IProfessor,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name, courseId, title, email } = params;

      filters.push(
        {
          field: 'filter[by_name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[by_course_id]',
          operator: 'eq',
          value: courseId
        },
        {
          field: 'filter[by_title]',
          operator: 'eq',
          value: title
        },
        {
          field: 'filter[by_email]',
          operator: 'eq',
          value: email
        }
      );

      return filters;
    }
  });
  const { selectProps: courseSelectProps } = useSelect<ICourse>({
    resource: 'graduate_courses',
    queryOptions: {
      enabled: Boolean(canListGraduateCourses.data?.can)
    },
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <ListLayout title="Professores">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="name">
          <Input placeholder="Nome do professor" suffix={<SearchOutlined />} />
        </Form.Item>

        <Form.Item name="email">
          <Input placeholder="E-mail do professor" />
        </Form.Item>

        <Form.Item name="courseId">
          <Select placeholder="Busque pelo curso" {...courseSelectProps} />
        </Form.Item>

        <Form.Item name="title">
          <Select placeholder="Título do professor">
            <Select.Option key="specialist">Especialista</Select.Option>
            <Select.Option key="master">Mestre</Select.Option>
            <Select.Option key="doctor">Doutor</Select.Option>
          </Select>
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="title"
          key="title"
          title="Título"
          render={value => (
            <TextField value={TitleMap[value as keyof typeof TitleMap]} />
          )}
        />
        <Table.Column
          dataIndex="courses_count"
          key="courses_count"
          title="Cursos"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="classrooms_count"
          key="classrooms_count"
          title="Turmas"
          render={value => <TextField value={value} />}
        />
        <Table.Column<IProfessor>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <Space>
                <ShowButton
                  hideText
                  size="small"
                  recordItemId={record.id}
                  accessControl={{ hideIfUnauthorized: true }}
                />
                <EditButton
                  hideText
                  size="small"
                  recordItemId={record.id}
                  accessControl={{ hideIfUnauthorized: true }}
                />
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
